
<template>
    <PasswordReset
        v-if="showPasswordResetDialog"
        v-model="whatsapp"
        :ddi="whatsappDdi"
        @reset="onReset"
        @login="showLogin"
        @close="showPasswordResetDialog = false"
    />
    <v-dialog v-else :value="true" persistent max-width="600">
        <v-card>
            <v-card-title class="headline">
                <v-spacer/>
                {{ hasAccount ? $t('conta.digiteSenha') : $t('conta.digiteWhatsapp') }}
                <v-spacer/>
                <v-btn
                    @click="$emit('close')"
                    icon
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="text-center mt-4">
                <TelefoneInput
                    ref="whatsapp"
                    type="tel"
                    :label="$t('conta.whatsapp')"
                    v-model="whatsapp"
                    :ddi.sync="whatsappDdi"
                    placeholder="(99) 99999-9999"
                    outlined
                    :disabled="hasAccount"
                    @keypress.enter="continuar"
                />
                <v-text-field
                    v-if="hasAccount"
                    ref="password"
                    :label="$t('conta.senha')"
                    v-model="password"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    @keypress.enter="login"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    outlined
                    dense
                />
                <div v-if="hasAccount" style="display: flex;">
                    <v-btn
                        @click="forgotPassword"
                        color="primary"
                        text
                        x-small
                    >{{ $t('conta.esqueciSenha') }}</v-btn>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    @click="continuar"
                    :loading="loading"
                    color="primary"
                    class="white--text"
                    block
                    large
                >
                    {{ hasAccount ? $t('envio.entrar') : $t('geral.continuar') }}
                    <v-icon class="ml-1">mdi-arrow-right</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>

        <CreateAccount
            v-if="showCreateAccountDialog"
            v-model="whatsapp"
            :ddi="whatsappDdi"
            @create="setToken"
            @close="showCreateAccountDialog = false"
        />
    </v-dialog>
</template>

<script>
import PasswordReset from './PasswordReset';
import CreateAccount from './CreateAccount';
import TelefoneInput from '@/components/TelefoneInput';
import enderecosApi from '@/utils/enderecos';
import { mapActions } from 'vuex';

export default {
    name: 'Login',

    components: {
        PasswordReset,
        CreateAccount,
        TelefoneInput,
    },

    data: () => ({
        loading: false,
        showPassword: false,
        hasAccount: false,
        whatsapp: '',
        whatsappDdi: null,
        password: '',
        showCreateAccountDialog: false,
        showPasswordResetDialog: false,
    }),

    mounted() {
        setTimeout(() => this.$refs.whatsapp.focus(), 100);
    },

    methods: {
        ...mapActions([
            'userAuthenticate',
        ]),

        continuar() {
            this.hasAccount ? this.login() : this.checkWhatsapp();
        },

        checkWhatsapp() {
            if (this.whatsapp.length < 10) {
                this.notify(this.$t('conta.whatsappInvalido'), 'warning');
                setTimeout(() => this.$refs.whatsapp.focus(), 100);
                return;
            }

            this.loading = true;
            const ddi = this.whatsappDdi ? `?whatsapp_ddi=${this.whatsappDdi}` : '';

            this.$http.get(`user/has-account/${this.whatsapp.replace(/\D/g, '')}${ddi}`).then(resp => {
                const data = resp.data

                if (data.type === 'warning') {
                    this.notify(data.msg, 'warning');
                    return;
                }

                if (data.data) {
                    this.hasAccount = true;
                    setTimeout(() => this.$refs.password.focus(), 100);
                } else {
                    this.showCreateAccountDialog = true;
                }
            }).finally(() => {
                this.loading = false;
            });
        },

        login() {
            if (!this.password.length) {
                this.notify(this.$t('conta.digiteASenha'), 'warning');
                setTimeout(() => this.$refs.password.focus(), 100);
                return;
            }

            this.loading = true;
            const data = { whatsapp: this.whatsapp, whatsapp_ddi: this.whatsappDdi, password: this.password };
            this.$http.post('login', data).then(resp => {
                console.log(resp);
                const data = resp.data

                if (data.type === 'warning') {
                    this.notify(data.msg, 'warning');
                    return;
                }

                this.setToken(data.data);
            }).finally(() => {
                this.loading = false;
            });
        },

        setToken(accessToken) {
            const name = this.$http.defaults.headers.common['emp'] + '-access-token';
            localStorage.setItem(name, accessToken);

            this.$http.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

            // autentica e, ao concluir, migra os endereços do convidado para a conta
            Promise.resolve(this.userAuthenticate())
                .then(() => enderecosApi.mergeLocalIntoAccount());

            this.$emit('login');
        },

        forgotPassword() {
            this.showPasswordResetDialog = true;
        },

        onReset(data) {
            this.setToken(data);
            this.$emit('login');
        },

        showLogin() {
            this.showPasswordResetDialog = false;
        },
    },
}
</script>
